// extracted by mini-css-extract-plugin
export default {"list":"RK51hodvx9EbBSEDxuQG"};